/** Tokens visuais — kits do evento (mesmo padrão dos recebimentos) */
export const KITS_ACCENT = "#F96030";
export const KITS_INK = "#1a2035";
export const KITS_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const kitsToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${KITS_ACCENT}`,
};

export const kitsSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const kitsModalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 480,
};

export const kitsModalHeaderSx = {
  px: 2.5,
  py: 2,
  background: `linear-gradient(135deg, ${KITS_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${KITS_ACCENT}`,
};

export const kitsFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
    minHeight: 44,
  },
};
